import { useResizeContext } from "datastake-daf/dist/context";
import { Header, TabsHeader } from 'datastake-daf/dist/components';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Style from './style';
import Filters from './filters';
import Monitoring from './monitoring';
import { SupplyChain } from './supply-chain';
import { useQueryParams } from '../../../../../../../helpers/useQuery';
import { tabsTypes } from '../../../../../../../components/dashboards/components/project-visualisation/conig';
import ProjectVisualisation from '../../../../../../../components/dashboards/components/project-visualisation';
import { useMemo } from "react";

const getTab = (tab) => {
  if (tab === tabsTypes.MONITORING) {
    return tabsTypes.MONITORING
  }
  if (tab === tabsTypes.SUPPLY_CHAIN) {
    return tabsTypes.SUPPLY_CHAIN
  }
  return tabsTypes.MONITORING;
}

const ProjectLayout = ({
  sources = [],
  data = {},
  selectedProject = null,
  t = (t) => t,
  language,
  projectData = null,
  user = null,
  organisationName = null,
  sourceId = null,
  isOwnData = true,
  retrived = false,
  PmeDashboardGet = () => { },
}) => {
  const { isCollapsed: sidebarCollapsed } = useResizeContext();
  const { query, push } = useQueryParams();
  const [activeTab, setActiveTab] = useState(getTab(query.get('activeTab')));
  const [supplyChainShown, setSupplyChainShown] = useState(activeTab === tabsTypes.SUPPLY_CHAIN);
  const [defaultSources, setDefaultSources] = useState(0);
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [focusParticipant, setFocusParticipant] = useState();
  const [reset, setReset] = useState(false);
  const [filterKey, setFilterKey] = useState();
  const mainRef = useRef();
  const [scrolls, setScrolls] = useState({
    [tabsTypes.SUPPLY_CHAIN]: 0.00001,
    [tabsTypes.MONITORING]: 0.00001,
  });

  useEffect(() => {
    if (filterKey) {
      setFilterKey(undefined);
    }
  }, [filterKey]);

  const openSettings = () => setSettingsVisible(true);

  useEffect(() => {
    if (reset) {
      setReset(false);
      PmeDashboardGet();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  useEffect(() => {
    push('activeTab', activeTab);
    if (activeTab === tabsTypes.SUPPLY_CHAIN && !supplyChainShown) {
      setSupplyChainShown(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  let settings = useMemo(() => (user?.settings?.projects || []).find((s) => s.id === projectData?.id) || {}, [user, projectData]);
  if (!settings) {
    settings = {};
  }
  if (!settings.defaultFilters && projectData?.config?.defaultFilters) {
    settings.defaultFilters = projectData?.config?.defaultFilters;
  }
  const props = {
    defaultSources,
    sources,
    settings,
    openSettings,
    setFocusParticipant,
    data,
    selectedProject,
    t,
    language,
    projectData,
    user,
    organisationName,
    sourceId,
    isOwnData,
    sidebarCollapsed,
    retrived,
    filterKey,
  };

  const _scrollEventListener = useCallback((e) => {
    setScrolls((prev) => {
      const _scroll = e.target.scrollTop;
      const _next = activeTab === tabsTypes.MONITORING ?
        tabsTypes.SUPPLY_CHAIN : tabsTypes.MONITORING;

      if (_scroll !== prev[_next]) {
        return {
          ...prev,
          [activeTab]: e.target.scrollTop,
        }
      }

      return prev;
    });
  }, [activeTab]);

  useEffect(() => {
    const val = scrolls[activeTab] || 0;
    mainRef.current.scrollTo({ top: val });

    mainRef.current.addEventListener('scroll', _scrollEventListener);
    return () => {
      if (mainRef?.current) {
        mainRef.current.removeEventListener('scroll', _scrollEventListener);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_scrollEventListener]);

  const _breadcrumbs = [
    { label: t('Analysis'), value: 'analysis' },
    { label: t('Consolidated Project Dashboard'), value: 'dashboard' }
  ];

  return (
    <Style>
      <Header
        title={t('Consolidated Project Dashboard')}
        breadcrumbs={_breadcrumbs}
        actionButtons={[
          { label: t('Settings'), type: 'primary', onClick: openSettings }
        ]}
      />

      <TabsHeader
        value={activeTab}
        onChange={(key) => setActiveTab(key)}
        tabs={[
          {
            label: t('Monitoring & Evaluation'),
            value: tabsTypes.MONITORING,
          },
          {
            label: t('Supply Chain'),
            value: tabsTypes.SUPPLY_CHAIN,
          }
        ]}
      />
      <div className="settings-header">
        <Filters
          openSettings={openSettings}
          activeTab={activeTab}
          setFilterKey={setFilterKey}
        />
      </div>
      {reset ? null : (
        <div className="dashboard-content p-0 main-container main-project-container" ref={mainRef}>
          <div
            className={activeTab !== tabsTypes.SUPPLY_CHAIN ? 'tab-cont' : undefined}
            style={{ height: activeTab !== tabsTypes.SUPPLY_CHAIN ? undefined : 0, overflow: 'hidden' }}
          >
            <Monitoring {...props} />
          </div>
          {supplyChainShown && (
            <div
              className={activeTab === tabsTypes.SUPPLY_CHAIN ? 'tab-cont' : undefined}
              style={{ height: activeTab === tabsTypes.SUPPLY_CHAIN ? undefined : 0, overflow: 'hidden' }}
            >
              <SupplyChain {...props} />
            </div>
          )}
        </div>
      )}
      {!!projectData && (
        <ProjectVisualisation
          setSettingsVisible={setSettingsVisible}
          settingsVisible={settingsVisible}
          projectData={projectData}
          setReset={setReset}
          activeTab={activeTab}
          setDefaultSources={setDefaultSources}
          focusParticipant={focusParticipant}
        />
      )}
    </Style>
  );
};

export default ProjectLayout;
